/* eslint-disable */
import type { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = {
  [K in keyof T]: T[K];
};
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]?: Maybe<T[SubKey]>;
};
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]: Maybe<T[SubKey]>;
};
export type MakeEmpty<
  T extends { [key: string]: unknown },
  K extends keyof T,
> = { [_ in K]?: never };
export type Incremental<T> =
  | T
  | {
      [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never;
    };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string };
  String: { input: string; output: string };
  Boolean: { input: boolean; output: boolean };
  Int: { input: number; output: number };
  Float: { input: number; output: number };
  /**
   * The `Date` scalar type represents a Date
   * value as specified by
   * [iso8601](https://en.wikipedia.org/wiki/ISO_8601).
   */
  Date: { input: string; output: string };
  /**
   * The `DateTime` scalar type represents a DateTime
   * value as specified by
   * [iso8601](https://en.wikipedia.org/wiki/ISO_8601).
   */
  DateTime: { input: any; output: any };
  /**
   * The `GenericScalar` scalar type represents a generic
   * GraphQL scalar value that could be:
   * String, Boolean, Int, Float, List or Object.
   */
  GenericScalar: { input: any; output: any };
  /**
   * Allows use of a JSON String for input / output from the GraphQL schema.
   *
   * Use of this type is *not recommended* as you lose the benefits of having a defined, static
   * schema (one of the key benefits of GraphQL).
   */
  JSONString: { input: string; output: string };
  /**
   * The `Time` scalar type represents a Time value as
   * specified by
   * [iso8601](https://en.wikipedia.org/wiki/ISO_8601).
   */
  Time: { input: any; output: any };
};

export type AccountDisabled = UserError & {
  __typename?: 'AccountDisabled';
  message: Maybe<Scalars['String']['output']>;
  status: Maybe<Scalars['Int']['output']>;
};

export type AccountType = {
  __typename?: 'AccountType';
  email: Maybe<Scalars['String']['output']>;
  id: Maybe<Scalars['Int']['output']>;
  profile: Maybe<ProfileType>;
};

export type AppointmentResult = AppointmentSuccess | FieldInvalid;

/** Response to request for available appointments */
export type AppointmentSuccess = {
  __typename?: 'AppointmentSuccess';
  counselorCount: Maybe<Scalars['Int']['output']>;
  counselors: Maybe<Array<Maybe<AvailableCounselorType>>>;
  foundFreeSlots: Maybe<Scalars['Boolean']['output']>;
  freeSlots: Maybe<Array<Maybe<FreeSlotType>>>;
};

/** Update input must contain at least one thing to change */
export type AtleastOneFieldRequired = UserError & {
  __typename?: 'AtleastOneFieldRequired';
  message: Maybe<Scalars['String']['output']>;
  status: Maybe<Scalars['Int']['output']>;
};

/** Data about an available counselor in response to appointments query */
export type AvailableCounselorType = {
  __typename?: 'AvailableCounselorType';
  counselorFullname: Maybe<Scalars['String']['output']>;
  counselorId: Maybe<Scalars['Int']['output']>;
};

export type CancelConsultResult = InsufficientPermissions | NotFound | Success;

export type CannotUpdateCompletedOrCancelledConsult = UserError & {
  __typename?: 'CannotUpdateCompletedOrCancelledConsult';
  message: Maybe<Scalars['String']['output']>;
  status: Maybe<Scalars['Int']['output']>;
};

export type ChangePasswordResult =
  | OldPasswordInvalid
  | PasswordInvalid
  | Success;

/** Input data for creating a consult */
export type ConsultInput = {
  bookedSlot?: InputMaybe<Scalars['DateTime']['input']>;
  counselorId?: InputMaybe<Scalars['Int']['input']>;
  customerprofileId?: InputMaybe<Scalars['ID']['input']>;
  email: Scalars['String']['input'];
  info?: InputMaybe<Scalars['String']['input']>;
  isInterpreterRequested?: InputMaybe<Scalars['Boolean']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  myriadAccessionId?: InputMaybe<Scalars['String']['input']>;
  onDemand?: InputMaybe<Scalars['Boolean']['input']>;
  participant?: InputMaybe<ParticipantInput>;
  phone: Scalars['String']['input'];
  state: Scalars['String']['input'];
  timezone?: InputMaybe<Scalars['String']['input']>;
  topic: Scalars['String']['input'];
};

/** Response data from querying consults */
export type ConsultListItemType = {
  __typename?: 'ConsultListItemType';
  bookedSlot: Maybe<Scalars['String']['output']>;
  counseleeId: Maybe<Scalars['ID']['output']>;
  counselor: Maybe<CounselorType>;
  created: Maybe<Scalars['DateTime']['output']>;
  email: Maybe<Scalars['String']['output']>;
  id: Maybe<Scalars['String']['output']>;
  onDemand: Maybe<Scalars['Boolean']['output']>;
  orderrequestExternalId: Maybe<Scalars['String']['output']>;
  participants: Maybe<Array<Participant>>;
  phone: Maybe<Scalars['String']['output']>;
  queueDescription: Maybe<QueueStatus>;
  report: Maybe<Scalars['String']['output']>;
  reportedOn: Maybe<Scalars['DateTime']['output']>;
  state: Maybe<Scalars['String']['output']>;
  status: Maybe<Scalars['String']['output']>;
  terminated: Maybe<Scalars['DateTime']['output']>;
  timezone: Maybe<Scalars['String']['output']>;
  topic: Maybe<Scalars['String']['output']>;
};

/** Response data from creating or updating a consult */
export type ConsultResponseType = {
  __typename?: 'ConsultResponseType';
  canCancel: Maybe<Scalars['Boolean']['output']>;
  consultId: Maybe<Scalars['Int']['output']>;
  counseleeId: Maybe<Scalars['Int']['output']>;
  counselorBiography: Maybe<Scalars['String']['output']>;
  counselorFirstName: Maybe<Scalars['String']['output']>;
  counselorFullname: Maybe<Scalars['String']['output']>;
  counselorId: Maybe<Scalars['Int']['output']>;
  counselorLastName: Maybe<Scalars['String']['output']>;
  counselorPic: Maybe<Scalars['String']['output']>;
  counselorRole: Maybe<Scalars['String']['output']>;
  email: Maybe<Scalars['String']['output']>;
  externalId: Maybe<Scalars['String']['output']>;
  isUnterminatedOndemand: Maybe<Scalars['Boolean']['output']>;
  onDemand: Maybe<Scalars['Boolean']['output']>;
  phone: Maybe<Scalars['String']['output']>;
  productName: Maybe<Scalars['String']['output']>;
  queueDescription: Maybe<QueueStatus>;
  reservationType: Maybe<Scalars['String']['output']>;
  resultsExternalId: Maybe<Scalars['String']['output']>;
  resultsViewableByPatient: Maybe<Scalars['Boolean']['output']>;
  serviceTypeDescription: Maybe<Scalars['String']['output']>;
  startTime: Maybe<Scalars['DateTime']['output']>;
  state: Maybe<Scalars['String']['output']>;
  timezone: Maybe<Scalars['String']['output']>;
  topic: Maybe<Scalars['String']['output']>;
};

/** Input data for updating a consult */
export type ConsultUpdateInput = {
  bookedSlot?: InputMaybe<Scalars['DateTime']['input']>;
  counselorId?: InputMaybe<Scalars['Int']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
};

export type ConsultationReportResult =
  | NotFound
  | ReportNotGenerated
  | ReportSuccess;

export type ConsultsListResult = ConsultsListSuccess | NotFound | UserNotFound;

export type ConsultsListSuccess = {
  __typename?: 'ConsultsListSuccess';
  consultList: Maybe<Array<ConsultListItemType>>;
};

/** Data about the genetic counselor for a consult */
export type CounselorType = {
  __typename?: 'CounselorType';
  bio: Maybe<Scalars['String']['output']>;
  firstName: Maybe<Scalars['String']['output']>;
  id: Maybe<Scalars['Int']['output']>;
  lastName: Maybe<Scalars['String']['output']>;
  photo: Maybe<Scalars['String']['output']>;
  role: Maybe<Scalars['String']['output']>;
};

export type CreateConsultResult =
  | CreateConsultSuccess
  | FieldInvalid
  | OnDemandNotAvailable
  | UserNotFound;

export type CreateConsultSuccess = {
  __typename?: 'CreateConsultSuccess';
  consult: Maybe<ConsultResponseType>;
};

export type EmailInvalid = UserError & {
  __typename?: 'EmailInvalid';
  issue: InvalidEmailPlain;
  message: Maybe<Scalars['String']['output']>;
  status: Maybe<Scalars['Int']['output']>;
  token: Maybe<Scalars['JSONString']['output']>;
};

export type Error = {
  __typename?: 'Error';
  errors: Maybe<Array<Scalars['String']['output']>>;
  info: Maybe<Scalars['String']['output']>;
  message: Maybe<Scalars['String']['output']>;
  status: Maybe<Scalars['Int']['output']>;
};

export type EstimateType = {
  __typename?: 'EstimateType';
  id: Maybe<Scalars['Int']['output']>;
  isReady: Maybe<Scalars['Boolean']['output']>;
};

/** An enumeration. */
export enum FetalSex {
  FEMALE = 'FEMALE',
  MALE = 'MALE',
  XX_XX = 'XX_XX',
  XX_XY = 'XX_XY',
  XY_XY = 'XY_XY',
  Y_DETECTED = 'Y_DETECTED',
  Y_NOT_DETECTED = 'Y_NOT_DETECTED',
}

/** Base interface for user errors involving fields */
export type FieldError = {
  fields: Maybe<Array<Scalars['String']['output']>>;
  message: Maybe<Scalars['String']['output']>;
  status: Maybe<Scalars['Int']['output']>;
};

/** Data in field is invalid */
export type FieldInvalid = FieldError &
  UserError & {
    __typename?: 'FieldInvalid';
    fields: Maybe<Array<Scalars['String']['output']>>;
    message: Maybe<Scalars['String']['output']>;
    status: Maybe<Scalars['Int']['output']>;
  };

/** A date for times slot for an appointment */
export type FreeSlotType = {
  __typename?: 'FreeSlotType';
  slotDate: Maybe<Scalars['Date']['output']>;
  slotHours: Maybe<Array<Maybe<SlotHourType>>>;
};

export type GetClinicalReportsResult =
  | NotFound
  | ReportNotReleased
  | ReportSuccess
  | UserNotFound;

export type GetOTPResult = FieldInvalid | OTPSuccess | RequiredInputFields;

export type GetRegistrationKeyResult =
  | GetRegistrationKeySuccess
  | RegistrationKeyAlreadyUsed
  | RegistrationKeyInvalid;

export type GetRegistrationKeySuccess = {
  __typename?: 'GetRegistrationKeySuccess';
  key: Maybe<RegistrationKeyResponseType>;
};

export type GetReportIdsResult =
  | FieldInvalid
  | GetReportIdsSuccess
  | NotFound
  | UserNotFound;

export type GetReportIdsSuccess = {
  __typename?: 'GetReportIdsSuccess';
  reportIds: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

/** The user does not have permissions for the specific object */
export type InsufficientPermissions = UserError & {
  __typename?: 'InsufficientPermissions';
  message: Maybe<Scalars['String']['output']>;
  status: Maybe<Scalars['Int']['output']>;
};

/** An enumeration. */
export enum InternalStatusFlow {
  ACCESSIONING_INCOMING = 'ACCESSIONING_INCOMING',
  ACCESSIONING_RECEIVED = 'ACCESSIONING_RECEIVED',
  CANCELED = 'CANCELED',
  CLS_REVIEW = 'CLS_REVIEW',
  COMPLETE = 'COMPLETE',
  CUSTOMER_OUTGOING = 'CUSTOMER_OUTGOING',
  CUSTOMER_RECEIVED = 'CUSTOMER_RECEIVED',
  DIRECTOR_REVIEW = 'DIRECTOR_REVIEW',
  FEDEX_ERROR = 'FEDEX_ERROR',
  FINAL_HOLD = 'FINAL_HOLD',
  GENDER_MISMATCH = 'GENDER_MISMATCH',
  GENERIC_ERROR = 'GENERIC_ERROR',
  HOLD = 'HOLD',
  INCORRECT_INFO = 'INCORRECT_INFO',
  INCORRECT_REMAILER = 'INCORRECT_REMAILER',
  INSURANCE_REVIEW = 'INSURANCE_REVIEW',
  INVALID_SHIPPING_ADDRESS = 'INVALID_SHIPPING_ADDRESS',
  INVALID_TRACKING_NUMBER = 'INVALID_TRACKING_NUMBER',
  LAB_COMPLETE = 'LAB_COMPLETE',
  LAB_PROCESSING = 'LAB_PROCESSING',
  LAB_PROCESSING_ERROR = 'LAB_PROCESSING_ERROR',
  MISSING_CARD = 'MISSING_CARD',
  MISSING_COLLECTION_DATE = 'MISSING_COLLECTION_DATE',
  MISSING_INFO = 'MISSING_INFO',
  MISSING_INFO_TERMINAL = 'MISSING_INFO_TERMINAL',
  MISSING_PHYSICIAN_SIGNATURE = 'MISSING_PHYSICIAN_SIGNATURE',
  ONLY_ONE_ACCEPTABLE_TUBE = 'ONLY_ONE_ACCEPTABLE_TUBE',
  ON_HOLD_FOR_PRE_TEST_COUNSELING = 'ON_HOLD_FOR_PRE_TEST_COUNSELING',
  PENDING = 'PENDING',
  PENDING_REPORT = 'PENDING_REPORT',
  REPORT_RECEIVED = 'REPORT_RECEIVED',
  REVIEW_ERROR = 'REVIEW_ERROR',
  SAMPLE_DAMAGED = 'SAMPLE_DAMAGED',
  SAMPLE_INSUFFICIENT = 'SAMPLE_INSUFFICIENT',
  SAMPLE_QC_FAILURE = 'SAMPLE_QC_FAILURE',
  SCIENCE_REVIEW = 'SCIENCE_REVIEW',
  TERMINATED = 'TERMINATED',
  TRACKED = 'TRACKED',
  TUBE_ABSENT = 'TUBE_ABSENT',
  TUBE_EMPTY = 'TUBE_EMPTY',
  TUBE_EXPIRED = 'TUBE_EXPIRED',
  TUBE_LEAKING = 'TUBE_LEAKING',
  TUBE_TYPE_UNACCEPTABLE = 'TUBE_TYPE_UNACCEPTABLE',
  VIRTUAL_SERVICE_ORDER_IN_DATA_ENTRY = 'VIRTUAL_SERVICE_ORDER_IN_DATA_ENTRY',
}

/** An enumeration. */
export enum InvalidEmailPlain {
  EMAIL_ALREADY_IN_USE = 'EMAIL_ALREADY_IN_USE',
  EMAIL_NOT_SUPPORTED_FOR_STAFF = 'EMAIL_NOT_SUPPORTED_FOR_STAFF',
  EMAIL_NOT_VALID = 'EMAIL_NOT_VALID',
  EMAIL_REQUIRED_FIELD_MISSING = 'EMAIL_REQUIRED_FIELD_MISSING',
}

/** An enumeration. */
export enum InvalidPasswordPlain {
  PASSWORD_NEEDS_DIGIT = 'PASSWORD_NEEDS_DIGIT',
  PASSWORD_NEEDS_LOWERCASE = 'PASSWORD_NEEDS_LOWERCASE',
  PASSWORD_NEEDS_UPPERCASE = 'PASSWORD_NEEDS_UPPERCASE',
  PASSWORD_NOT_VALID = 'PASSWORD_NOT_VALID',
  PASSWORD_TOO_SHORT = 'PASSWORD_TOO_SHORT',
}

export type LoginFailed = UserError & {
  __typename?: 'LoginFailed';
  message: Maybe<Scalars['String']['output']>;
  status: Maybe<Scalars['Int']['output']>;
  token: Maybe<Scalars['JSONString']['output']>;
};

export type LoginResult = LoginFailed | LoginSuccess;

export type LoginSuccess = {
  __typename?: 'LoginSuccess';
  account: Maybe<AccountType>;
  refreshToken: Maybe<Scalars['String']['output']>;
  token: Maybe<Scalars['JSONString']['output']>;
};

export type LogoutResult = Error | Success;

export type Mutation = {
  __typename?: 'Mutation';
  /** Mark a consult as cancelled, does not actually delete */
  cancelConsult: Maybe<CancelConsultResult>;
  changePassword: Maybe<ChangePasswordResult>;
  /** Schedule a consult for patient */
  createConsult: Maybe<CreateConsultResult>;
  /** Request a verification code through SMS or phone call */
  getOneTimePassword: Maybe<GetOTPResult>;
  /** Get registration key with a barcode, invoice number, or accession id */
  getRegistrationKey: Maybe<GetRegistrationKeyResult>;
  login: Maybe<LoginResult>;
  logout: Maybe<LogoutResult>;
  refreshToken: Maybe<Refresh>;
  register: Maybe<RegisterResult>;
  /** Final step for a patient to claim an order (aka testkit) */
  registrationClaims: Maybe<RegistrationClaimsResult>;
  /**
   * This mutation starts a process that could lead to a password reset.
   * Website will send out email with link if successful
   */
  requestResetPassword: Maybe<RequestResetResult>;
  /**
   * This mutation completes the process of resetting a password, will change the password in
   * website and Keycloak if successful
   */
  resetPassword: Maybe<ResetResult>;
  /** Update a consult for patient */
  updateConsult: Maybe<UpdateConsultResult>;
  updateProfile: Maybe<UpdateProfileResult>;
  /** Verify requested one time password for registration */
  verifyOneTimePassword: Maybe<VerifyRegistrationPersonalInfoResult>;
  /** Verify registration personal information with KEY_NAME_DOB */
  verifyRegistrationPersonalInfo: Maybe<VerifyRegistrationPersonalInfoResult>;
  verifyToken: Maybe<Verify>;
};

export type MutationcancelConsultArgs = {
  id: Scalars['String']['input'];
};

export type MutationchangePasswordArgs = {
  newPassword: Scalars['String']['input'];
  oldPassword: Scalars['String']['input'];
};

export type MutationcreateConsultArgs = {
  input?: InputMaybe<ConsultInput>;
};

export type MutationgetOneTimePasswordArgs = {
  input?: InputMaybe<VerifyWithSmsInput>;
  registrationKey?: InputMaybe<Scalars['String']['input']>;
  verificationMethod: Scalars['String']['input'];
};

export type MutationgetRegistrationKeyArgs = {
  identifier: Scalars['String']['input'];
};

export type MutationloginArgs = {
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
};

export type MutationrefreshTokenArgs = {
  token?: InputMaybe<Scalars['String']['input']>;
};

export type MutationregisterArgs = {
  email: Scalars['String']['input'];
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  password: Scalars['String']['input'];
};

export type MutationregistrationClaimsArgs = {
  regToken: Scalars['String']['input'];
};

export type MutationrequestResetPasswordArgs = {
  email: Scalars['String']['input'];
};

export type MutationresetPasswordArgs = {
  key: Scalars['String']['input'];
  password: Scalars['String']['input'];
};

export type MutationupdateConsultArgs = {
  id: Scalars['String']['input'];
  input?: InputMaybe<ConsultUpdateInput>;
};

export type MutationupdateProfileArgs = {
  input?: InputMaybe<ProfileInputType>;
};

export type MutationverifyOneTimePasswordArgs = {
  input?: InputMaybe<VerifyOTPInput>;
  registrationKey?: InputMaybe<Scalars['String']['input']>;
  verificationMethod: Scalars['String']['input'];
};

export type MutationverifyRegistrationPersonalInfoArgs = {
  input?: InputMaybe<VerifyPersonalInfoInput>;
  registrationKey: Scalars['String']['input'];
  verificationMethod: Scalars['String']['input'];
};

export type MutationverifyTokenArgs = {
  token?: InputMaybe<Scalars['String']['input']>;
};

/** The specific object requested doesn't exist */
export type NotFound = UserError & {
  __typename?: 'NotFound';
  message: Maybe<Scalars['String']['output']>;
  status: Maybe<Scalars['Int']['output']>;
};

export type OTPSuccess = {
  __typename?: 'OTPSuccess';
  oneTimePassword: Scalars['String']['output'];
};

export type OldPasswordInvalid = UserError & {
  __typename?: 'OldPasswordInvalid';
  message: Maybe<Scalars['String']['output']>;
  status: Maybe<Scalars['Int']['output']>;
};

export type OnDemandAvailResult = FieldInvalid | OnDemandAvailSuccess;

/** Simple true or false as to whether ondemand counselling is available at asking time */
export type OnDemandAvailSuccess = {
  __typename?: 'OnDemandAvailSuccess';
  available: Maybe<Scalars['Boolean']['output']>;
};

export type OnDemandNotAvailable = UserError & {
  __typename?: 'OnDemandNotAvailable';
  message: Maybe<Scalars['String']['output']>;
  status: Maybe<Scalars['Int']['output']>;
};

/**
 * This is for the MPP status tracker, where we only have the
 * current status to send at any given time.
 */
export type OneStepStatusTrackerType = {
  __typename?: 'OneStepStatusTrackerType';
  internalFlowStatus: Maybe<InternalStatusFlow>;
  isMerged: Maybe<Scalars['Boolean']['output']>;
  overallStatus: Maybe<Scalars['String']['output']>;
};

export type OrderBillingInfo = {
  __typename?: 'OrderBillingInfo';
  creditCard: Maybe<OrderCreditCard>;
  description: Maybe<Scalars['String']['output']>;
  partnerPrimaryInsuranceCard: Maybe<OrderBillingInfoInsurance>;
  partnerSecondaryInsuranceCard: Maybe<OrderBillingInfoInsurance>;
  primaryInsuranceCard: Maybe<OrderBillingInfoInsurance>;
  secondaryInsuranceCard: Maybe<OrderBillingInfoInsurance>;
};

/** Insurance information of patient or subscriber from the insurance card. */
export type OrderBillingInfoInsurance = {
  __typename?: 'OrderBillingInfoInsurance';
  groupNumber: Maybe<Scalars['String']['output']>;
  insuranceProvider: Maybe<Scalars['String']['output']>;
  memberId: Maybe<Scalars['String']['output']>;
  patientAddress1: Maybe<Scalars['String']['output']>;
  patientAddress2: Maybe<Scalars['String']['output']>;
  patientCity: Maybe<Scalars['String']['output']>;
  patientDob: Maybe<Scalars['Date']['output']>;
  patientFirstName: Maybe<Scalars['String']['output']>;
  patientLastName: Maybe<Scalars['String']['output']>;
  patientPostalCode: Maybe<Scalars['String']['output']>;
  patientState: Maybe<Scalars['String']['output']>;
  relationshipToInsured: Maybe<Scalars['String']['output']>;
};

/**
 * This object is under the OrderPatient, which is under OrderDetails. Optional, could be
 * insurance card or credit card
 */
export type OrderCreditCard = {
  __typename?: 'OrderCreditCard';
  expMonth: Maybe<Scalars['String']['output']>;
  expYear: Maybe<Scalars['String']['output']>;
  last4: Maybe<Scalars['String']['output']>;
  name: Maybe<Scalars['String']['output']>;
  type: Maybe<Scalars['String']['output']>;
};

/** Convert REST API response from results order details to the Graphql one */
export type OrderDetailsResponse = {
  __typename?: 'OrderDetailsResponse';
  accessionDate: Maybe<Scalars['Date']['output']>;
  billType: Maybe<Scalars['String']['output']>;
  billingInfo: Maybe<OrderBillingInfo>;
  hasReleasedResults: Maybe<Scalars['Boolean']['output']>;
  isPreliminaryReport: Maybe<Scalars['Boolean']['output']>;
  orderingClinic: Maybe<Scalars['String']['output']>;
  orderingProvider: Maybe<Scalars['String']['output']>;
  partner: Maybe<OrderPatient>;
  patient: Maybe<OrderPatient>;
  productId: Maybe<Scalars['Int']['output']>;
  productName: Maybe<Scalars['String']['output']>;
  receivingProvider: Maybe<OrderProvider>;
  resultsReleased: Maybe<Scalars['Date']['output']>;
  resultsViewableByPatient: Maybe<Scalars['Boolean']['output']>;
  sampleTracker: Maybe<SampleTracker>;
  shipping: Maybe<OrderShipping>;
};

export type OrderDetailsResult =
  | InsufficientPermissions
  | NotFound
  | OrderDetailsSuccess
  | UserNotFound;

/** Convert REST API response from results order details to the Graphql one */
export type OrderDetailsSuccess = {
  __typename?: 'OrderDetailsSuccess';
  detail: Maybe<OrderDetailsResponse>;
};

/**
 * This object is under the OrderPatient, which is under OrderDetails. Optional, could be
 * insurance card or credit card
 */
export type OrderInsurance = {
  __typename?: 'OrderInsurance';
  groupNumber: Maybe<Scalars['String']['output']>;
  memberId: Maybe<Scalars['String']['output']>;
  patientAddress1: Maybe<Scalars['String']['output']>;
  patientAddress2: Maybe<Scalars['String']['output']>;
  patientCity: Maybe<Scalars['String']['output']>;
  patientDob: Maybe<Scalars['Date']['output']>;
  patientFirstName: Maybe<Scalars['String']['output']>;
  patientLastName: Maybe<Scalars['String']['output']>;
  patientPostalCode: Maybe<Scalars['String']['output']>;
  patientState: Maybe<Scalars['String']['output']>;
  relationshipToInsured: Maybe<Scalars['String']['output']>;
  subscriberAddress1: Maybe<Scalars['String']['output']>;
  subscriberAddress2: Maybe<Scalars['String']['output']>;
  subscriberCity: Maybe<Scalars['String']['output']>;
  subscriberDob: Maybe<Scalars['Date']['output']>;
  subscriberFirstName: Maybe<Scalars['String']['output']>;
  subscriberLastName: Maybe<Scalars['String']['output']>;
  subscriberPostalCode: Maybe<Scalars['String']['output']>;
  subscriberState: Maybe<Scalars['String']['output']>;
};

export type OrderItemType = {
  __typename?: 'OrderItemType';
  accessionId: Maybe<Scalars['String']['output']>;
  canAccessOrderDetails: Maybe<Scalars['Boolean']['output']>;
  createDate: Maybe<Scalars['DateTime']['output']>;
  customerprofileId: Maybe<Scalars['Int']['output']>;
  externalId: Maybe<Scalars['String']['output']>;
  hasReleasedResults: Maybe<Scalars['Boolean']['output']>;
  includeEstimateAlert: Maybe<Scalars['Boolean']['output']>;
  isOwnerProfile: Maybe<Scalars['Boolean']['output']>;
  isTandemReflex: Maybe<Scalars['Boolean']['output']>;
  isWaitingOnMergedResults: Maybe<Scalars['Boolean']['output']>;
  orderRequestExternalId: Maybe<Scalars['String']['output']>;
  orderRequestUuid: Maybe<Scalars['String']['output']>;
  patientFirstName: Maybe<Scalars['String']['output']>;
  patientLastName: Maybe<Scalars['String']['output']>;
  pricingEstimates: Maybe<Array<Maybe<EstimateType>>>;
  product: Maybe<Scalars['String']['output']>;
  productId: Maybe<Scalars['String']['output']>;
  resultExternalId: Maybe<Scalars['String']['output']>;
  resultsManagementEnabled: Maybe<Scalars['Boolean']['output']>;
  resultsReleasedToPatient: Maybe<Scalars['Date']['output']>;
  sampleTracker: Maybe<SampleTracker>;
};

/** Type for patient information in Order Details, used for both the patient and the partner */
export type OrderPatient = {
  __typename?: 'OrderPatient';
  barcode: Maybe<Scalars['String']['output']>;
  canEditInsurance: Maybe<Scalars['Boolean']['output']>;
  creditCard: Maybe<OrderCreditCard>;
  dob: Maybe<Scalars['Date']['output']>;
  firstName: Maybe<Scalars['String']['output']>;
  gender: Maybe<Scalars['String']['output']>;
  insuranceCard: Maybe<OrderInsurance>;
  isFullDiscount: Maybe<Scalars['Boolean']['output']>;
  kitExternalId: Maybe<Scalars['String']['output']>;
  lastName: Maybe<Scalars['String']['output']>;
  price: Maybe<Scalars['String']['output']>;
  productName: Maybe<Scalars['String']['output']>;
  refund: Maybe<Scalars['Boolean']['output']>;
  reportDate: Maybe<Scalars['String']['output']>;
  sample: Maybe<Scalars['String']['output']>;
  sampleReceived: Maybe<Scalars['Date']['output']>;
  shippingCost: Maybe<Scalars['String']['output']>;
  tests: Maybe<Array<OrderTest>>;
};

export type OrderProvider = {
  __typename?: 'OrderProvider';
  clinicLocation: Maybe<Scalars['String']['output']>;
  clinicName: Maybe<Scalars['String']['output']>;
  name: Maybe<Scalars['String']['output']>;
};

/** This object is part of OrderPatient, which is under OrderDetails */
export type OrderShipping = {
  __typename?: 'OrderShipping';
  shipAddress1: Maybe<Scalars['String']['output']>;
  shipAddress2: Maybe<Scalars['String']['output']>;
  shipCity: Maybe<Scalars['String']['output']>;
  shipCountry: Maybe<Scalars['String']['output']>;
  shipFirstName: Maybe<Scalars['String']['output']>;
  shipLastName: Maybe<Scalars['String']['output']>;
  shipPostalCode: Maybe<Scalars['String']['output']>;
  shipState: Maybe<Scalars['String']['output']>;
  shippingOption: Maybe<Scalars['String']['output']>;
  shippingPhone: Maybe<Scalars['String']['output']>;
  shippingStatus: Maybe<Scalars['String']['output']>;
  trackingNumber: Maybe<Scalars['String']['output']>;
};

export type OrderTest = {
  __typename?: 'OrderTest';
  about: Maybe<Scalars['String']['output']>;
  conditions: Maybe<Scalars['String']['output']>;
  diseasePanel: Maybe<Scalars['String']['output']>;
  name: Maybe<Scalars['String']['output']>;
  reportDate: Maybe<Scalars['Date']['output']>;
  testedDiseaseCount: Maybe<Scalars['Int']['output']>;
  type: Maybe<OrderTestType>;
};

/** An enumeration. */
export enum OrderTestType {
  BRACANALYSIS = 'BRACANALYSIS',
  COLARIS = 'COLARIS',
  COLARIS_AP = 'COLARIS_AP',
  FIRST_GENE = 'FIRST_GENE',
  FORESIGHT = 'FORESIGHT',
  MULTISITE3 = 'MULTISITE3',
  MYRISK = 'MYRISK',
  MYRISK_UPDATE = 'MYRISK_UPDATE',
  PREQUEL = 'PREQUEL',
  UNSUPPORTED = 'UNSUPPORTED',
}

export type OrdersListResponse = OrdersListSuccess | UserNotFound;

export type OrdersListSuccess = {
  __typename?: 'OrdersListSuccess';
  ordersCount: Maybe<Scalars['Int']['output']>;
  ordersList: Maybe<Array<OrderItemType>>;
  partialsCount: Maybe<Scalars['Int']['output']>;
  partialsList: Maybe<Array<PartialItemType>>;
};

export type PartialItemType = {
  __typename?: 'PartialItemType';
  createDate: Maybe<Scalars['DateTime']['output']>;
  product: Maybe<Scalars['String']['output']>;
  uuid: Maybe<Scalars['String']['output']>;
};

export type Participant = {
  __typename?: 'Participant';
  firstName: Maybe<Scalars['String']['output']>;
  lastName: Maybe<Scalars['String']['output']>;
};

export type ParticipantInput = {
  dob: Scalars['Date']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
};

export type PasswordInvalid = UserError & {
  __typename?: 'PasswordInvalid';
  message: Maybe<Scalars['String']['output']>;
  problem: InvalidPasswordPlain;
  status: Maybe<Scalars['Int']['output']>;
  token: Maybe<Scalars['JSONString']['output']>;
};

export type PatientResultType = {
  __typename?: 'PatientResultType';
  firstName: Maybe<Scalars['String']['output']>;
  resultDescription: Maybe<Scalars['String']['output']>;
  resultType: Maybe<Scalars['String']['output']>;
};

export type PatientType = {
  __typename?: 'PatientType';
  accessionId: Maybe<Scalars['String']['output']>;
  email: Maybe<Scalars['String']['output']>;
  firstName: Maybe<Scalars['String']['output']>;
  lastName: Maybe<Scalars['String']['output']>;
  phone: Maybe<Scalars['String']['output']>;
};

export type PhoneNumberInvalid = UserError & {
  __typename?: 'PhoneNumberInvalid';
  message: Maybe<Scalars['String']['output']>;
  status: Maybe<Scalars['Int']['output']>;
};

export type ProfileInputType = {
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
};

export type ProfileType = {
  __typename?: 'ProfileType';
  firstName: Maybe<Scalars['String']['output']>;
  lastName: Maybe<Scalars['String']['output']>;
  phoneNumber: Maybe<Scalars['String']['output']>;
  timezone: Maybe<Scalars['String']['output']>;
};

export type Query = {
  __typename?: 'Query';
  account: Maybe<AccountType>;
  appointments: Maybe<AppointmentResult>;
  consultReport: Maybe<ConsultationReportResult>;
  consults: Maybe<ConsultsListResult>;
  getClinicalReport: Maybe<GetClinicalReportsResult>;
  getReportIds: Maybe<GetReportIdsResult>;
  onDemandAvailable: Maybe<OnDemandAvailResult>;
  orderDetails: Maybe<OrderDetailsResult>;
  orders: Maybe<OrdersListResponse>;
  queueStatus: Maybe<QueueStatusResult>;
  resultsOverview: Maybe<ResultsOverviewResult>;
  validateRecoveryKey: Maybe<RecoveryKeyResponse>;
};

export type QueryappointmentsArgs = {
  counselorId?: InputMaybe<Scalars['String']['input']>;
  state: Scalars['String']['input'];
  topic: Scalars['String']['input'];
  userTimezone?: InputMaybe<Scalars['String']['input']>;
};

export type QueryconsultReportArgs = {
  id: Scalars['String']['input'];
};

export type QueryconsultsArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
};

export type QuerygetClinicalReportArgs = {
  orderRequestId: Scalars['String']['input'];
  reportUuid: Scalars['String']['input'];
};

export type QuerygetReportIdsArgs = {
  orderRequestId: Scalars['String']['input'];
};

export type QueryonDemandAvailableArgs = {
  topic: Scalars['String']['input'];
};

export type QueryorderDetailsArgs = {
  externalId: Scalars['String']['input'];
};

export type QueryordersArgs = {
  detailed?: InputMaybe<Scalars['Boolean']['input']>;
  myriskOnly?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryqueueStatusArgs = {
  consultId?: InputMaybe<Scalars['String']['input']>;
};

export type QueryresultsOverviewArgs = {
  orderRequestId: Scalars['String']['input'];
};

export type QueryvalidateRecoveryKeyArgs = {
  key?: InputMaybe<Scalars['String']['input']>;
};

/** An enumeration. */
export enum QueuePositionPlain {
  ACCEPTED = 'ACCEPTED',
  CANCELLED = 'CANCELLED',
  COMPLETED = 'COMPLETED',
  MULTIPLE_ONDEMAND_FOUND = 'MULTIPLE_ONDEMAND_FOUND',
  NEXT = 'NEXT',
  NOSHOW = 'NOSHOW',
  NOT_SET = 'NOT_SET',
  NO_ONDEMAND_FOUND = 'NO_ONDEMAND_FOUND',
  WAITING = 'WAITING',
}

/** Latest status for an on-demand consult */
export type QueueStatus = {
  __typename?: 'QueueStatus';
  aheadCount: Maybe<Scalars['Int']['output']>;
  consultExternalId: Maybe<Scalars['String']['output']>;
  gcFirstname: Maybe<Scalars['String']['output']>;
  gcFullname: Maybe<Scalars['String']['output']>;
  phone: Maybe<Scalars['String']['output']>;
  position: Maybe<QueuePositionPlain>;
  stopPolling: Maybe<Scalars['Boolean']['output']>;
};

export type QueueStatusResult = NotFound | QueueStatusSuccess | UserNotFound;

export type QueueStatusSuccess = {
  __typename?: 'QueueStatusSuccess';
  aheadCount: Maybe<Scalars['Int']['output']>;
  consultExternalId: Maybe<Scalars['String']['output']>;
  gcFirstname: Maybe<Scalars['String']['output']>;
  gcFullname: Maybe<Scalars['String']['output']>;
  phone: Maybe<Scalars['String']['output']>;
  position: Maybe<QueuePositionPlain>;
  stopPolling: Maybe<Scalars['Boolean']['output']>;
};

export type RecoveryKeyInvalid = UserError & {
  __typename?: 'RecoveryKeyInvalid';
  message: Maybe<Scalars['String']['output']>;
  status: Maybe<Scalars['Int']['output']>;
};

export type RecoveryKeyResponse = NotFound | Success;

export type Refresh = {
  __typename?: 'Refresh';
  payload: Scalars['GenericScalar']['output'];
  refreshExpiresIn: Scalars['Int']['output'];
  token: Scalars['String']['output'];
};

export type RegisterResult =
  | EmailInvalid
  | LoginFailed
  | PasswordInvalid
  | RegisterSuccess;

export type RegisterSuccess = {
  __typename?: 'RegisterSuccess';
  account: Maybe<AccountType>;
  token: Maybe<Scalars['JSONString']['output']>;
};

export type RegistrationClaimsResult =
  | FieldInvalid
  | NotFound
  | Success
  | UserNotFound;

export type RegistrationKeyAlreadyUsed = UserError & {
  __typename?: 'RegistrationKeyAlreadyUsed';
  message: Maybe<Scalars['String']['output']>;
  status: Maybe<Scalars['Int']['output']>;
};

export type RegistrationKeyInvalid = UserError & {
  __typename?: 'RegistrationKeyInvalid';
  message: Maybe<Scalars['String']['output']>;
  status: Maybe<Scalars['Int']['output']>;
};

export type RegistrationKeyResponseType = {
  __typename?: 'RegistrationKeyResponseType';
  registrationKey: Maybe<Scalars['String']['output']>;
};

export type Release = {
  __typename?: 'Release';
  isAmended: Maybe<Scalars['Boolean']['output']>;
  isCorrected: Maybe<Scalars['Boolean']['output']>;
  isFinal: Maybe<Scalars['Boolean']['output']>;
  releaseDate: Maybe<Scalars['Date']['output']>;
  releaseDescription: Maybe<Scalars['String']['output']>;
  releaseFor: Maybe<Scalars['String']['output']>;
  releaseLabel: Maybe<Scalars['String']['output']>;
  reportId: Maybe<Scalars['String']['output']>;
};

/** The requested report hasn't been generated yet */
export type ReportNotGenerated = UserError & {
  __typename?: 'ReportNotGenerated';
  message: Maybe<Scalars['String']['output']>;
  status: Maybe<Scalars['Int']['output']>;
};

/** ClinicalReport Not Released */
export type ReportNotReleased = UserError & {
  __typename?: 'ReportNotReleased';
  message: Maybe<Scalars['String']['output']>;
  status: Maybe<Scalars['Int']['output']>;
};

/** Report is base64 encoded string containing a pdf report back from Website */
export type ReportSuccess = {
  __typename?: 'ReportSuccess';
  contentType: Maybe<Scalars['String']['output']>;
  filename: Maybe<Scalars['String']['output']>;
  report: Maybe<Scalars['String']['output']>;
};

export type RequestResetResult = EmailInvalid | Success;

export type RequiredInputFields = UserError & {
  __typename?: 'RequiredInputFields';
  message: Maybe<Scalars['String']['output']>;
  status: Maybe<Scalars['Int']['output']>;
};

export type ResetResult =
  | AccountDisabled
  | PasswordInvalid
  | RecoveryKeyInvalid
  | Success;

export type ResultProduct = {
  __typename?: 'ResultProduct';
  id: Maybe<Scalars['Int']['output']>;
  name: Maybe<Scalars['String']['output']>;
  slug: Maybe<Scalars['String']['output']>;
};

/** An enumeration. */
export enum ResultSeverity {
  ELEVATED_RISK = 'ELEVATED_RISK',
  HIGH_RISK = 'HIGH_RISK',
  INCONCLUSIVE = 'INCONCLUSIVE',
  NEGATIVE = 'NEGATIVE',
  NO_RESULT = 'NO_RESULT',
  POSSIBLE_RISK = 'POSSIBLE_RISK',
}

/** An enumeration. */
export enum ResultStatus {
  NONE = 'NONE',
  PROCESSING = 'PROCESSING',
  RESULTS = 'RESULTS',
}

export type ResultsOverviewResult =
  | NotFound
  | ReportNotReleased
  | ResultsOverviewSuccess
  | UserNotFound;

export type ResultsOverviewSuccess = {
  __typename?: 'ResultsOverviewSuccess';
  mostSevereResult: Maybe<Scalars['String']['output']>;
  overallSeverity: Maybe<ResultSeverity>;
  overallStatus: Maybe<ResultStatus>;
  patient: Maybe<PatientType>;
  product: Maybe<ResultProduct>;
  releaseHistory: Maybe<Array<Release>>;
  resultsReleased: Maybe<Scalars['Date']['output']>;
  testResults: Maybe<Array<Maybe<TestResultType>>>;
  tests: Maybe<Array<TestType>>;
  whoseResults: Maybe<Scalars['String']['output']>;
};

export type SampleTracker = {
  __typename?: 'SampleTracker';
  lastUpdated: Maybe<Scalars['DateTime']['output']>;
  oneStepStatusTracker: Maybe<OneStepStatusTrackerType>;
  sampleName: Maybe<Scalars['String']['output']>;
  statusSummary: Maybe<Scalars['String']['output']>;
  statusTrackers: Maybe<Array<StatusTracker>>;
};

/** Identifies the counselor associated with an available time slot */
export type SlotCounselorType = {
  __typename?: 'SlotCounselorType';
  counselorId: Maybe<Scalars['Int']['output']>;
};

/** An available time slot for an appointment */
export type SlotHourType = {
  __typename?: 'SlotHourType';
  slotCounselors: Maybe<Array<Maybe<SlotCounselorType>>>;
  slotHour: Maybe<Scalars['Time']['output']>;
};

export type StatusTracker = {
  __typename?: 'StatusTracker';
  icon: Maybe<Scalars['String']['output']>;
  patientName: Maybe<Scalars['String']['output']>;
  trackerName: Maybe<Scalars['String']['output']>;
  trackerSteps: Maybe<Array<TrackerStep>>;
};

/** Generic success response type */
export type Success = {
  __typename?: 'Success';
  message: Maybe<Scalars['String']['output']>;
  status: Maybe<Scalars['Int']['output']>;
};

export type TestResultType = {
  __typename?: 'TestResultType';
  childAffectedOdds: Maybe<Scalars['String']['output']>;
  conditionLevel: Maybe<Scalars['String']['output']>;
  conditionName: Maybe<Scalars['String']['output']>;
  conditionSynonyms: Maybe<Scalars['String']['output']>;
  fullDescription: Maybe<Scalars['String']['output']>;
  patientResults: Maybe<Array<Maybe<PatientResultType>>>;
  shortDescription: Maybe<Scalars['String']['output']>;
};

/** An enumeration. */
export enum TestStatus {
  CANCELLED = 'CANCELLED',
  OTHER = 'OTHER',
  RELEASED = 'RELEASED',
  REPORTED = 'REPORTED',
}

export type TestType = {
  __typename?: 'TestType';
  fetalSex: Maybe<FetalSex>;
  isTwinPregnancy: Maybe<Scalars['Boolean']['output']>;
  reportId: Maybe<Scalars['String']['output']>;
  resultsReleasedToPatient: Maybe<Scalars['Date']['output']>;
  resultsViewedByPatient: Maybe<Scalars['Boolean']['output']>;
  testName: Maybe<Scalars['String']['output']>;
  testSeverity: Maybe<ResultSeverity>;
  testStatus: Maybe<TestStatus>;
};

export type TimezoneInvalid = UserError & {
  __typename?: 'TimezoneInvalid';
  message: Maybe<Scalars['String']['output']>;
  status: Maybe<Scalars['Int']['output']>;
};

export type TrackerStep = {
  __typename?: 'TrackerStep';
  description: Maybe<Scalars['String']['output']>;
  label: Maybe<Scalars['String']['output']>;
  name: Maybe<Scalars['String']['output']>;
  status: Maybe<Scalars['String']['output']>;
  stepDate: Maybe<Scalars['DateTime']['output']>;
};

export type UpdateConsultResult =
  | AtleastOneFieldRequired
  | CannotUpdateCompletedOrCancelledConsult
  | FieldInvalid
  | InsufficientPermissions
  | NotFound
  | UpdateConsultSuccess;

/** Input data for updating a consult */
export type UpdateConsultSuccess = {
  __typename?: 'UpdateConsultSuccess';
  consult: Maybe<ConsultResponseType>;
};

export type UpdateProfileResult =
  | EmailInvalid
  | PhoneNumberInvalid
  | TimezoneInvalid
  | UpdateProfileSuccess;

export type UpdateProfileSuccess = {
  __typename?: 'UpdateProfileSuccess';
  account: Maybe<AccountType>;
};

/** Base interface for user actionable errors */
export type UserError = {
  message: Maybe<Scalars['String']['output']>;
  status: Maybe<Scalars['Int']['output']>;
};

/** The user requested doesn't exist, or they don't have an account */
export type UserNotFound = UserError & {
  __typename?: 'UserNotFound';
  message: Maybe<Scalars['String']['output']>;
  status: Maybe<Scalars['Int']['output']>;
};

export type VerificationFailed = UserError & {
  __typename?: 'VerificationFailed';
  message: Maybe<Scalars['String']['output']>;
  status: Maybe<Scalars['Int']['output']>;
};

export type Verify = {
  __typename?: 'Verify';
  payload: Scalars['GenericScalar']['output'];
};

export type VerifyOTPInput = {
  dateOfBirth?: InputMaybe<Scalars['Date']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  oneTimePassword?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
};

export type VerifyPersonalInfoInput = {
  dateOfBirth?: InputMaybe<Scalars['Date']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
};

export type VerifyRegistrationPersonalInfoResult =
  | FieldInvalid
  | RequiredInputFields
  | VerificationFailed
  | VerifySuccess;

export type VerifySuccess = {
  __typename?: 'VerifySuccess';
  regToken: Scalars['String']['output'];
};

export type VerifyWithSmsInput = {
  dateOfBirth?: InputMaybe<Scalars['Date']['input']>;
  deliveryMethod?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
};

export type LoginMutationVariables = Exact<{
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
}>;

export type LoginMutation = {
  __typename?: 'Mutation';
  login:
    | { __typename: 'LoginFailed' }
    | {
        __typename: 'LoginSuccess';
        token: string | null;
        account: {
          __typename?: 'AccountType';
          email: string | null;
          profile: {
            __typename?: 'ProfileType';
            firstName: string | null;
            lastName: string | null;
          } | null;
        } | null;
      }
    | null;
};

export type LogoutMutationVariables = Exact<{ [key: string]: never }>;

export type LogoutMutation = {
  __typename?: 'Mutation';
  logout: { __typename: 'Error' } | { __typename: 'Success' } | null;
};

export type RegisterMutationVariables = Exact<{
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
}>;

export type RegisterMutation = {
  __typename?: 'Mutation';
  register:
    | { __typename?: 'EmailInvalid'; issue: InvalidEmailPlain }
    | { __typename?: 'LoginFailed' }
    | { __typename?: 'PasswordInvalid' }
    | {
        __typename?: 'RegisterSuccess';
        token: string | null;
        account: {
          __typename?: 'AccountType';
          email: string | null;
          profile: {
            __typename?: 'ProfileType';
            firstName: string | null;
            lastName: string | null;
          } | null;
        } | null;
      }
    | null;
};

export type UserInfoQueryVariables = Exact<{ [key: string]: never }>;

export type UserInfoQuery = {
  __typename?: 'Query';
  account: {
    __typename?: 'AccountType';
    email: string | null;
    profile: {
      __typename?: 'ProfileType';
      firstName: string | null;
      lastName: string | null;
    } | null;
  } | null;
};

export type RefreshTokenMutationVariables = Exact<{ [key: string]: never }>;

export type RefreshTokenMutation = {
  __typename?: 'Mutation';
  refreshToken: { __typename?: 'Refresh'; token: string } | null;
};

export type ChangePasswordMutationVariables = Exact<{
  newPassword: Scalars['String']['input'];
  oldPassword: Scalars['String']['input'];
}>;

export type ChangePasswordMutation = {
  __typename?: 'Mutation';
  changePassword:
    | { __typename: 'OldPasswordInvalid' }
    | { __typename: 'PasswordInvalid' }
    | { __typename: 'Success' }
    | null;
};

export type RequestResetPasswordMutationVariables = Exact<{
  email: Scalars['String']['input'];
}>;

export type RequestResetPasswordMutation = {
  __typename?: 'Mutation';
  requestResetPassword:
    | { __typename: 'EmailInvalid' }
    | { __typename: 'Success' }
    | null;
};

export type ResetPasswordMutationVariables = Exact<{
  key: Scalars['String']['input'];
  password: Scalars['String']['input'];
}>;

export type ResetPasswordMutation = {
  __typename?: 'Mutation';
  resetPassword:
    | { __typename: 'AccountDisabled' }
    | { __typename: 'PasswordInvalid' }
    | { __typename: 'RecoveryKeyInvalid' }
    | { __typename: 'Success' }
    | null;
};

export type GetConsultsQueryVariables = Exact<{ [key: string]: never }>;

export type GetConsultsQuery = {
  __typename?: 'Query';
  consults:
    | {
        __typename: 'ConsultsListSuccess';
        consultList: Array<{
          __typename?: 'ConsultListItemType';
          id: string | null;
          onDemand: boolean | null;
          created: any | null;
          reportedOn: any | null;
          report: string | null;
          phone: string | null;
          status: string | null;
          topic: string | null;
          bookedSlot: string | null;
          email: string | null;
          orderrequestExternalId: string | null;
          participants: Array<{
            __typename?: 'Participant';
            firstName: string | null;
          }> | null;
          queueDescription: {
            __typename?: 'QueueStatus';
            aheadCount: number | null;
          } | null;
          counselor: {
            __typename?: 'CounselorType';
            bio: string | null;
            firstName: string | null;
            id: number | null;
            lastName: string | null;
            photo: string | null;
          } | null;
        }> | null;
      }
    | { __typename: 'NotFound' }
    | { __typename: 'UserNotFound' }
    | null;
};

export type GetConsultQueryVariables = Exact<{
  id?: InputMaybe<Scalars['String']['input']>;
}>;

export type GetConsultQuery = {
  __typename?: 'Query';
  consults:
    | {
        __typename: 'ConsultsListSuccess';
        consultList: Array<{
          __typename?: 'ConsultListItemType';
          id: string | null;
          onDemand: boolean | null;
          created: any | null;
          phone: string | null;
          status: string | null;
          state: string | null;
          topic: string | null;
          bookedSlot: string | null;
          counselor: {
            __typename?: 'CounselorType';
            bio: string | null;
            firstName: string | null;
            id: number | null;
            lastName: string | null;
            photo: string | null;
          } | null;
        }> | null;
      }
    | { __typename: 'NotFound' }
    | { __typename: 'UserNotFound' }
    | null;
};

export type GetAppointmentsQueryVariables = Exact<{
  state: Scalars['String']['input'];
  topic: Scalars['String']['input'];
}>;

export type GetAppointmentsQuery = {
  __typename?: 'Query';
  appointments:
    | {
        __typename: 'AppointmentSuccess';
        foundFreeSlots: boolean | null;
        freeSlots: Array<{
          __typename?: 'FreeSlotType';
          slotDate: string | null;
          slotHours: Array<{
            __typename?: 'SlotHourType';
            slotHour: any | null;
            slotCounselors: Array<{
              __typename?: 'SlotCounselorType';
              counselorId: number | null;
            } | null> | null;
          } | null> | null;
        } | null> | null;
        counselors: Array<{
          __typename?: 'AvailableCounselorType';
          counselorFullname: string | null;
          counselorId: number | null;
        } | null> | null;
      }
    | { __typename: 'FieldInvalid' }
    | null;
};

export type UpdateConsultMutationVariables = Exact<{
  id: Scalars['String']['input'];
  input?: InputMaybe<ConsultUpdateInput>;
}>;

export type UpdateConsultMutation = {
  __typename?: 'Mutation';
  updateConsult:
    | { __typename: 'AtleastOneFieldRequired' }
    | { __typename: 'CannotUpdateCompletedOrCancelledConsult' }
    | { __typename: 'FieldInvalid' }
    | { __typename: 'InsufficientPermissions' }
    | { __typename: 'NotFound' }
    | {
        __typename: 'UpdateConsultSuccess';
        consult: {
          __typename?: 'ConsultResponseType';
          consultId: number | null;
        } | null;
      }
    | null;
};

export type CreateConsultMutationVariables = Exact<{
  input?: InputMaybe<ConsultInput>;
}>;

export type CreateConsultMutation = {
  __typename?: 'Mutation';
  createConsult:
    | {
        __typename: 'CreateConsultSuccess';
        consult: {
          __typename?: 'ConsultResponseType';
          consultId: number | null;
        } | null;
      }
    | { __typename: 'FieldInvalid' }
    | { __typename: 'OnDemandNotAvailable' }
    | { __typename: 'UserNotFound' }
    | null;
};

export type OnDemandAvailableQueryVariables = Exact<{
  topic: Scalars['String']['input'];
}>;

export type OnDemandAvailableQuery = {
  __typename?: 'Query';
  onDemandAvailable:
    | {
        __typename: 'FieldInvalid';
        message: string | null;
        fields: Array<string> | null;
        status: number | null;
      }
    | { __typename: 'OnDemandAvailSuccess'; available: boolean | null }
    | null;
};

export type CreateOnDemandConsultMutationVariables = Exact<{
  input?: InputMaybe<ConsultInput>;
}>;

export type CreateOnDemandConsultMutation = {
  __typename?: 'Mutation';
  createConsult:
    | {
        __typename: 'CreateConsultSuccess';
        consult: {
          __typename?: 'ConsultResponseType';
          consultId: number | null;
        } | null;
      }
    | { __typename: 'FieldInvalid' }
    | { __typename: 'OnDemandNotAvailable' }
    | { __typename: 'UserNotFound' }
    | null;
};

export type CancelAppointmentMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;

export type CancelAppointmentMutation = {
  __typename?: 'Mutation';
  cancelConsult:
    | { __typename: 'InsufficientPermissions' }
    | { __typename: 'NotFound' }
    | { __typename: 'Success' }
    | null;
};

export type GetOrdersQueryVariables = Exact<{ [key: string]: never }>;

export type GetOrdersQuery = {
  __typename: 'Query';
  orders:
    | {
        __typename: 'OrdersListSuccess';
        ordersList: Array<{
          __typename?: 'OrderItemType';
          customerprofileId: number | null;
        }> | null;
      }
    | { __typename: 'UserNotFound' }
    | null;
};

export type GetOrdersUPPQueryVariables = Exact<{
  myriskOnly: Scalars['Boolean']['input'];
}>;

export type GetOrdersUPPQuery = {
  __typename: 'Query';
  orders:
    | {
        __typename: 'OrdersListSuccess';
        ordersList: Array<{
          __typename?: 'OrderItemType';
          product: string | null;
          productId: string | null;
          patientFirstName: string | null;
          createDate: any | null;
          hasReleasedResults: boolean | null;
          resultsReleasedToPatient: string | null;
          accessionId: string | null;
          customerprofileId: number | null;
          externalId: string | null;
        }> | null;
      }
    | { __typename: 'UserNotFound' }
    | null;
};

export type GetConsultReportQueryVariables = Exact<{
  consultId: Scalars['String']['input'];
}>;

export type GetConsultReportQuery = {
  __typename?: 'Query';
  consultReport:
    | { __typename: 'NotFound' }
    | { __typename: 'ReportNotGenerated' }
    | {
        __typename: 'ReportSuccess';
        report: string | null;
        filename: string | null;
        contentType: string | null;
      }
    | null;
};

export type GetCompletedConsultsQueryVariables = Exact<{
  [key: string]: never;
}>;

export type GetCompletedConsultsQuery = {
  __typename?: 'Query';
  consults:
    | {
        __typename: 'ConsultsListSuccess';
        consultList: Array<{
          __typename?: 'ConsultListItemType';
          id: string | null;
          counseleeId: string | null;
          bookedSlot: string | null;
          terminated: any | null;
          reportedOn: any | null;
          topic: string | null;
          report: string | null;
          status: string | null;
          counselor: {
            __typename?: 'CounselorType';
            firstName: string | null;
            lastName: string | null;
          } | null;
          participants: Array<{
            __typename?: 'Participant';
            firstName: string | null;
            lastName: string | null;
          }> | null;
        }> | null;
      }
    | { __typename: 'NotFound' }
    | { __typename: 'UserNotFound' }
    | null;
};

export type CheckRecoveryKeyQueryVariables = Exact<{
  key: Scalars['String']['input'];
}>;

export type CheckRecoveryKeyQuery = {
  __typename?: 'Query';
  validateRecoveryKey:
    | { __typename: 'NotFound' }
    | { __typename: 'Success' }
    | null;
};

export type VerifyIdentityQueryVariables = Exact<{ [key: string]: never }>;

export type VerifyIdentityQuery = {
  __typename?: 'Query';
  orders:
    | { __typename: 'OrdersListSuccess'; ordersCount: number | null }
    | { __typename: 'UserNotFound' }
    | null;
};

export type VerifyIdentityWithBarcodeQueryVariables = Exact<{
  [key: string]: never;
}>;

export type VerifyIdentityWithBarcodeQuery = {
  __typename?: 'Query';
  orders:
    | { __typename: 'OrdersListSuccess'; ordersCount: number | null }
    | { __typename: 'UserNotFound' }
    | null;
};

export type VerifyIdentityWithRecoveryKeyQueryVariables = Exact<{
  [key: string]: never;
}>;

export type VerifyIdentityWithRecoveryKeyQuery = {
  __typename?: 'Query';
  orders:
    | { __typename: 'OrdersListSuccess'; ordersCount: number | null }
    | { __typename: 'UserNotFound' }
    | null;
};

export type VerifyIdentityWithRegistrationKeyMutationVariables = Exact<{
  input: VerifyPersonalInfoInput;
  registrationKey: Scalars['String']['input'];
  verificationMethod: Scalars['String']['input'];
}>;

export type VerifyIdentityWithRegistrationKeyMutation = {
  __typename?: 'Mutation';
  verifyRegistrationPersonalInfo:
    | { __typename: 'FieldInvalid'; message: string | null }
    | { __typename: 'RequiredInputFields'; message: string | null }
    | { __typename: 'VerificationFailed'; message: string | null }
    | { __typename: 'VerifySuccess'; regToken: string }
    | null;
};

export type VerifyBarcodeQueryVariables = Exact<{ [key: string]: never }>;

export type VerifyBarcodeQuery = {
  __typename?: 'Query';
  orders:
    | { __typename: 'OrdersListSuccess'; ordersCount: number | null }
    | { __typename: 'UserNotFound' }
    | null;
};

export type ValidateRecoveryKeyQueryVariables = Exact<{ [key: string]: never }>;

export type ValidateRecoveryKeyQuery = {
  __typename?: 'Query';
  orders:
    | { __typename: 'OrdersListSuccess'; ordersCount: number | null }
    | { __typename: 'UserNotFound' }
    | null;
};

export type GetOneTimePasswordNameDOBPhoneMutationVariables = Exact<{
  input: VerifyWithSmsInput;
  verificationMethod: Scalars['String']['input'];
}>;

export type GetOneTimePasswordNameDOBPhoneMutation = {
  __typename?: 'Mutation';
  getOneTimePassword:
    | { __typename: 'FieldInvalid'; message: string | null }
    | { __typename: 'OTPSuccess' }
    | { __typename: 'RequiredInputFields'; message: string | null }
    | null;
};

export type RequestRegistrationKeyWithBarcodeMutationVariables = Exact<{
  identifier: Scalars['String']['input'];
}>;

export type RequestRegistrationKeyWithBarcodeMutation = {
  __typename?: 'Mutation';
  getRegistrationKey:
    | {
        __typename: 'GetRegistrationKeySuccess';
        key: {
          __typename?: 'RegistrationKeyResponseType';
          registrationKey: string | null;
        } | null;
      }
    | { __typename: 'RegistrationKeyAlreadyUsed'; message: string | null }
    | { __typename: 'RegistrationKeyInvalid'; message: string | null }
    | null;
};

export type RequestVerificationCodeWithRecoveryKeyQueryVariables = Exact<{
  [key: string]: never;
}>;

export type RequestVerificationCodeWithRecoveryKeyQuery = {
  __typename?: 'Query';
  orders:
    | { __typename: 'OrdersListSuccess'; ordersCount: number | null }
    | { __typename: 'UserNotFound' }
    | null;
};

export type GetOneTimePasswordMutationVariables = Exact<{
  input: VerifyWithSmsInput;
  verificationMethod: Scalars['String']['input'];
  registrationKey: Scalars['String']['input'];
}>;

export type GetOneTimePasswordMutation = {
  __typename?: 'Mutation';
  getOneTimePassword:
    | { __typename: 'FieldInvalid'; message: string | null }
    | { __typename: 'OTPSuccess' }
    | { __typename: 'RequiredInputFields'; message: string | null }
    | null;
};

export type VerifyOneTimePasswordNameDOBPhoneMutationVariables = Exact<{
  input: VerifyOTPInput;
  verificationMethod: Scalars['String']['input'];
}>;

export type VerifyOneTimePasswordNameDOBPhoneMutation = {
  __typename?: 'Mutation';
  verifyOneTimePassword:
    | { __typename: 'FieldInvalid'; message: string | null }
    | { __typename: 'RequiredInputFields'; message: string | null }
    | { __typename: 'VerificationFailed'; message: string | null }
    | { __typename: 'VerifySuccess'; regToken: string }
    | null;
};

export type VerifyOneTimePasswordRegistrationKeyMutationVariables = Exact<{
  input: VerifyOTPInput;
  verificationMethod: Scalars['String']['input'];
  registrationKey: Scalars['String']['input'];
}>;

export type VerifyOneTimePasswordRegistrationKeyMutation = {
  __typename?: 'Mutation';
  verifyOneTimePassword:
    | { __typename: 'FieldInvalid'; message: string | null }
    | { __typename: 'RequiredInputFields'; message: string | null }
    | { __typename: 'VerificationFailed'; message: string | null }
    | { __typename: 'VerifySuccess'; regToken: string }
    | null;
};

export type ClaimTestMutationVariables = Exact<{
  claimsToken: Scalars['String']['input'];
}>;

export type ClaimTestMutation = {
  __typename?: 'Mutation';
  registrationClaims:
    | { __typename: 'FieldInvalid' }
    | { __typename: 'NotFound' }
    | { __typename: 'Success' }
    | { __typename: 'UserNotFound' }
    | null;
};

export type GetMyRiskOrdersQueryVariables = Exact<{ [key: string]: never }>;

export type GetMyRiskOrdersQuery = {
  __typename?: 'Query';
  orders:
    | {
        __typename: 'OrdersListSuccess';
        ordersList: Array<{
          __typename?: 'OrderItemType';
          externalId: string | null;
          accessionId: string | null;
          createDate: any | null;
          hasReleasedResults: boolean | null;
          product: string | null;
          patientFirstName: string | null;
          patientLastName: string | null;
          sampleTracker: {
            __typename?: 'SampleTracker';
            statusSummary: string | null;
            sampleName: string | null;
            lastUpdated: any | null;
            oneStepStatusTracker: {
              __typename?: 'OneStepStatusTrackerType';
              overallStatus: string | null;
              internalFlowStatus: InternalStatusFlow | null;
              isMerged: boolean | null;
            } | null;
            statusTrackers: Array<{
              __typename?: 'StatusTracker';
              patientName: string | null;
              trackerName: string | null;
              icon: string | null;
              trackerSteps: Array<{
                __typename?: 'TrackerStep';
                name: string | null;
                status: string | null;
                label: string | null;
                description: string | null;
                stepDate: any | null;
              }> | null;
            }> | null;
          } | null;
        }> | null;
      }
    | { __typename: 'UserNotFound' }
    | null;
};

export type ResultsOverviewQueryVariables = Exact<{
  orderRequestId: Scalars['String']['input'];
}>;

export type ResultsOverviewQuery = {
  __typename?: 'Query';
  resultsOverview:
    | { __typename: 'NotFound'; status: number | null; message: string | null }
    | {
        __typename: 'ReportNotReleased';
        status: number | null;
        message: string | null;
      }
    | {
        __typename: 'ResultsOverviewSuccess';
        overallSeverity: ResultSeverity | null;
        resultsReleased: string | null;
        product: {
          __typename?: 'ResultProduct';
          id: number | null;
          name: string | null;
          slug: string | null;
        } | null;
        patient: {
          __typename?: 'PatientType';
          email: string | null;
          phone: string | null;
          firstName: string | null;
          lastName: string | null;
          accessionId: string | null;
        } | null;
        tests: Array<{
          __typename?: 'TestType';
          testName: string | null;
          testStatus: TestStatus | null;
          testSeverity: ResultSeverity | null;
          reportId: string | null;
          resultsReleasedToPatient: string | null;
          resultsViewedByPatient: boolean | null;
        }> | null;
      }
    | {
        __typename: 'UserNotFound';
        status: number | null;
        message: string | null;
      }
    | null;
};

export type ReportsIDQueryVariables = Exact<{
  orderRequestId: Scalars['String']['input'];
}>;

export type ReportsIDQuery = {
  __typename?: 'Query';
  getReportIds:
    | { __typename: 'FieldInvalid' }
    | {
        __typename: 'GetReportIdsSuccess';
        reportIds: Array<string | null> | null;
      }
    | { __typename: 'NotFound' }
    | { __typename: 'UserNotFound' }
    | null;
};

export type ClinicalReportQueryVariables = Exact<{
  reportUuid: Scalars['String']['input'];
  orderRequestId: Scalars['String']['input'];
}>;

export type ClinicalReportQuery = {
  __typename?: 'Query';
  getClinicalReport:
    | { __typename: 'NotFound' }
    | { __typename: 'ReportNotReleased' }
    | {
        __typename: 'ReportSuccess';
        contentType: string | null;
        filename: string | null;
        report: string | null;
      }
    | { __typename: 'UserNotFound' }
    | null;
};

export type GetOrderDetailsQueryVariables = Exact<{
  externalId: Scalars['String']['input'];
}>;

export type GetOrderDetailsQuery = {
  __typename?: 'Query';
  orderDetails:
    | { __typename: 'InsufficientPermissions' }
    | { __typename: 'NotFound' }
    | {
        __typename: 'OrderDetailsSuccess';
        detail: {
          __typename?: 'OrderDetailsResponse';
          accessionDate: string | null;
          orderingProvider: string | null;
          orderingClinic: string | null;
          patient: {
            __typename?: 'OrderPatient';
            firstName: string | null;
            lastName: string | null;
            gender: string | null;
            dob: string | null;
            barcode: string | null;
            sampleReceived: string | null;
            tests: Array<{
              __typename?: 'OrderTest';
              type: OrderTestType | null;
              diseasePanel: string | null;
              testedDiseaseCount: number | null;
              conditions: string | null;
              reportDate: string | null;
            }> | null;
          } | null;
          receivingProvider: {
            __typename?: 'OrderProvider';
            name: string | null;
            clinicName: string | null;
            clinicLocation: string | null;
          } | null;
          billingInfo: {
            __typename?: 'OrderBillingInfo';
            description: string | null;
            primaryInsuranceCard: {
              __typename?: 'OrderBillingInfoInsurance';
              insuranceProvider: string | null;
              patientFirstName: string | null;
              patientLastName: string | null;
              patientAddress1: string | null;
              patientAddress2: string | null;
              patientCity: string | null;
              patientState: string | null;
              patientPostalCode: string | null;
              patientDob: string | null;
              relationshipToInsured: string | null;
              memberId: string | null;
              groupNumber: string | null;
            } | null;
            secondaryInsuranceCard: {
              __typename?: 'OrderBillingInfoInsurance';
              insuranceProvider: string | null;
              patientFirstName: string | null;
              patientLastName: string | null;
              patientAddress1: string | null;
              patientAddress2: string | null;
              patientCity: string | null;
              patientState: string | null;
              patientPostalCode: string | null;
              patientDob: string | null;
              relationshipToInsured: string | null;
              memberId: string | null;
              groupNumber: string | null;
            } | null;
            partnerPrimaryInsuranceCard: {
              __typename?: 'OrderBillingInfoInsurance';
              insuranceProvider: string | null;
              patientFirstName: string | null;
              patientLastName: string | null;
              patientAddress1: string | null;
              patientAddress2: string | null;
              patientCity: string | null;
              patientState: string | null;
              patientPostalCode: string | null;
              patientDob: string | null;
              relationshipToInsured: string | null;
              memberId: string | null;
              groupNumber: string | null;
            } | null;
            partnerSecondaryInsuranceCard: {
              __typename?: 'OrderBillingInfoInsurance';
              insuranceProvider: string | null;
              patientFirstName: string | null;
              patientLastName: string | null;
              patientAddress1: string | null;
              patientAddress2: string | null;
              patientCity: string | null;
              patientState: string | null;
              patientPostalCode: string | null;
              patientDob: string | null;
              relationshipToInsured: string | null;
              memberId: string | null;
              groupNumber: string | null;
            } | null;
            creditCard: {
              __typename?: 'OrderCreditCard';
              name: string | null;
              type: string | null;
              last4: string | null;
              expMonth: string | null;
              expYear: string | null;
            } | null;
          } | null;
        } | null;
      }
    | { __typename: 'UserNotFound' }
    | null;
};

export type GetOrderRequestResultsReleasedQueryVariables = Exact<{
  externalId: Scalars['String']['input'];
}>;

export type GetOrderRequestResultsReleasedQuery = {
  __typename?: 'Query';
  orderDetails:
    | { __typename: 'InsufficientPermissions' }
    | { __typename: 'NotFound' }
    | {
        __typename: 'OrderDetailsSuccess';
        detail: {
          __typename?: 'OrderDetailsResponse';
          hasReleasedResults: boolean | null;
        } | null;
      }
    | { __typename: 'UserNotFound' }
    | null;
};

export type GetMyAccountQueryVariables = Exact<{ [key: string]: never }>;

export type GetMyAccountQuery = {
  __typename?: 'Query';
  account: {
    __typename?: 'AccountType';
    email: string | null;
    profile: {
      __typename?: 'ProfileType';
      firstName: string | null;
      lastName: string | null;
      phoneNumber: string | null;
      timezone: string | null;
    } | null;
  } | null;
};

export type UpdateAccountDetailsMutationVariables = Exact<{
  input?: InputMaybe<ProfileInputType>;
}>;

export type UpdateAccountDetailsMutation = {
  __typename?: 'Mutation';
  updateProfile:
    | { __typename: 'EmailInvalid' }
    | { __typename: 'PhoneNumberInvalid' }
    | { __typename: 'TimezoneInvalid' }
    | {
        __typename: 'UpdateProfileSuccess';
        account: {
          __typename?: 'AccountType';
          email: string | null;
          profile: {
            __typename?: 'ProfileType';
            firstName: string | null;
            lastName: string | null;
            phoneNumber: string | null;
            timezone: string | null;
          } | null;
        } | null;
      }
    | null;
};

export type UpdateAccountAddressMutationVariables = Exact<{
  input?: InputMaybe<ProfileInputType>;
}>;

export type UpdateAccountAddressMutation = {
  __typename?: 'Mutation';
  updateProfile:
    | { __typename: 'EmailInvalid' }
    | { __typename: 'PhoneNumberInvalid' }
    | { __typename: 'TimezoneInvalid' }
    | {
        __typename: 'UpdateProfileSuccess';
        account: {
          __typename?: 'AccountType';
          email: string | null;
          profile: {
            __typename?: 'ProfileType';
            firstName: string | null;
            lastName: string | null;
            phoneNumber: string | null;
            timezone: string | null;
          } | null;
        } | null;
      }
    | null;
};

export const LoginDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'Login' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'email' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'password' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'login' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'email' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'email' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'password' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'password' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'LoginSuccess' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'account' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'email' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'profile' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'firstName' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'lastName' },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'token' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<LoginMutation, LoginMutationVariables>;
export const LogoutDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'Logout' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'logout' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<LogoutMutation, LogoutMutationVariables>;
export const RegisterDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'Register' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'firstName' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'lastName' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'email' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'password' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'register' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'email' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'email' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'firstName' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'firstName' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'lastName' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'lastName' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'password' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'password' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'RegisterSuccess' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'account' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'email' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'profile' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'firstName' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'lastName' },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'token' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'EmailInvalid' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'issue' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<RegisterMutation, RegisterMutationVariables>;
export const UserInfoDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'UserInfo' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'account' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'profile' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'firstName' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'lastName' },
                      },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'email' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UserInfoQuery, UserInfoQueryVariables>;
export const RefreshTokenDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'RefreshToken' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'refreshToken' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'token' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  RefreshTokenMutation,
  RefreshTokenMutationVariables
>;
export const ChangePasswordDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'ChangePassword' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'newPassword' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'oldPassword' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'changePassword' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'newPassword' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'newPassword' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'oldPassword' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'oldPassword' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ChangePasswordMutation,
  ChangePasswordMutationVariables
>;
export const RequestResetPasswordDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'RequestResetPassword' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'email' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'requestResetPassword' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'email' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'email' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  RequestResetPasswordMutation,
  RequestResetPasswordMutationVariables
>;
export const ResetPasswordDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'ResetPassword' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'key' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'password' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'resetPassword' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'key' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'key' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'password' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'password' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ResetPasswordMutation,
  ResetPasswordMutationVariables
>;
export const GetConsultsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetConsults' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'consults' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'ConsultsListSuccess' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'consultList' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'onDemand' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'created' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'reportedOn' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'report' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'phone' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'status' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'topic' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'bookedSlot' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'email' },
                            },
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'orderrequestExternalId',
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'participants' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'firstName' },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'queueDescription' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'aheadCount' },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'counselor' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'bio' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'firstName' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'id' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'lastName' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'photo' },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetConsultsQuery, GetConsultsQueryVariables>;
export const GetConsultDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetConsult' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'consults' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'id' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'ConsultsListSuccess' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'consultList' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'onDemand' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'created' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'phone' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'status' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'state' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'topic' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'bookedSlot' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'counselor' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'bio' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'firstName' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'id' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'lastName' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'photo' },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetConsultQuery, GetConsultQueryVariables>;
export const GetAppointmentsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetAppointments' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'state' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'topic' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'appointments' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'state' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'state' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'topic' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'topic' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'AppointmentSuccess' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'freeSlots' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'slotDate' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'slotHours' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'slotHour' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'slotCounselors',
                                    },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'counselorId',
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'foundFreeSlots' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'counselors' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'counselorFullname',
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'counselorId' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetAppointmentsQuery,
  GetAppointmentsQueryVariables
>;
export const UpdateConsultDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateConsult' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'ConsultUpdateInput' },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateConsult' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'id' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'UpdateConsultSuccess' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'consult' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'consultId' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateConsultMutation,
  UpdateConsultMutationVariables
>;
export const CreateConsultDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreateConsult' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'ConsultInput' },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createConsult' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'CreateConsultSuccess' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'consult' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'consultId' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CreateConsultMutation,
  CreateConsultMutationVariables
>;
export const OnDemandAvailableDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'OnDemandAvailable' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'topic' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'onDemandAvailable' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'topic' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'topic' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'FieldInvalid' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'message' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'fields' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'status' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'OnDemandAvailSuccess' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'available' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  OnDemandAvailableQuery,
  OnDemandAvailableQueryVariables
>;
export const CreateOnDemandConsultDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreateOnDemandConsult' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'ConsultInput' },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createConsult' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'CreateConsultSuccess' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'consult' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'consultId' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CreateOnDemandConsultMutation,
  CreateOnDemandConsultMutationVariables
>;
export const CancelAppointmentDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CancelAppointment' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'cancelConsult' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'id' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CancelAppointmentMutation,
  CancelAppointmentMutationVariables
>;
export const GetOrdersDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetOrders' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'orders' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'OrdersListSuccess' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'ordersList' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'customerprofileId',
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetOrdersQuery, GetOrdersQueryVariables>;
export const GetOrdersUPPDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetOrdersUPP' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'myriskOnly' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'Boolean' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'orders' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'myriskOnly' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'myriskOnly' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'OrdersListSuccess' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'ordersList' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'product' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'productId' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'patientFirstName' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'createDate' },
                            },
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'hasReleasedResults',
                              },
                            },
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'resultsReleasedToPatient',
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'accessionId' },
                            },
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'customerprofileId',
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'externalId' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetOrdersUPPQuery, GetOrdersUPPQueryVariables>;
export const GetConsultReportDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetConsultReport' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'consultId' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'consultReport' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'consultId' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'ReportSuccess' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'report' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'filename' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'contentType' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetConsultReportQuery,
  GetConsultReportQueryVariables
>;
export const GetCompletedConsultsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetCompletedConsults' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'consults' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'ConsultsListSuccess' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'consultList' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'counseleeId' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'bookedSlot' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'terminated' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'reportedOn' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'topic' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'report' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'counselor' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'firstName' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'lastName' },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'participants' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'firstName' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'lastName' },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'status' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetCompletedConsultsQuery,
  GetCompletedConsultsQueryVariables
>;
export const CheckRecoveryKeyDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CheckRecoveryKey' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'key' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'validateRecoveryKey' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'key' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'key' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CheckRecoveryKeyQuery,
  CheckRecoveryKeyQueryVariables
>;
export const VerifyIdentityDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'VerifyIdentity' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'orders' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'OrdersListSuccess' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'ordersCount' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<VerifyIdentityQuery, VerifyIdentityQueryVariables>;
export const VerifyIdentityWithBarcodeDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'VerifyIdentityWithBarcode' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'orders' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'OrdersListSuccess' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'ordersCount' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  VerifyIdentityWithBarcodeQuery,
  VerifyIdentityWithBarcodeQueryVariables
>;
export const VerifyIdentityWithRecoveryKeyDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'VerifyIdentityWithRecoveryKey' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'orders' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'OrdersListSuccess' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'ordersCount' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  VerifyIdentityWithRecoveryKeyQuery,
  VerifyIdentityWithRecoveryKeyQueryVariables
>;
export const VerifyIdentityWithRegistrationKeyDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'VerifyIdentityWithRegistrationKey' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'VerifyPersonalInfoInput' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'registrationKey' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'verificationMethod' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'verifyRegistrationPersonalInfo' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'verificationMethod' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'verificationMethod' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'registrationKey' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'registrationKey' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'VerifySuccess' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'regToken' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'UserError' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'message' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  VerifyIdentityWithRegistrationKeyMutation,
  VerifyIdentityWithRegistrationKeyMutationVariables
>;
export const VerifyBarcodeDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'VerifyBarcode' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'orders' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'OrdersListSuccess' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'ordersCount' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<VerifyBarcodeQuery, VerifyBarcodeQueryVariables>;
export const ValidateRecoveryKeyDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ValidateRecoveryKey' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'orders' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'OrdersListSuccess' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'ordersCount' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ValidateRecoveryKeyQuery,
  ValidateRecoveryKeyQueryVariables
>;
export const GetOneTimePasswordNameDOBPhoneDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'GetOneTimePasswordNameDOBPhone' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'VerifyWithSmsInput' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'verificationMethod' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getOneTimePassword' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'verificationMethod' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'verificationMethod' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'UserError' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'message' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetOneTimePasswordNameDOBPhoneMutation,
  GetOneTimePasswordNameDOBPhoneMutationVariables
>;
export const RequestRegistrationKeyWithBarcodeDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'RequestRegistrationKeyWithBarcode' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'identifier' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getRegistrationKey' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'identifier' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'identifier' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'GetRegistrationKeySuccess' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'key' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'registrationKey' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'UserError' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'message' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  RequestRegistrationKeyWithBarcodeMutation,
  RequestRegistrationKeyWithBarcodeMutationVariables
>;
export const RequestVerificationCodeWithRecoveryKeyDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'RequestVerificationCodeWithRecoveryKey' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'orders' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'OrdersListSuccess' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'ordersCount' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  RequestVerificationCodeWithRecoveryKeyQuery,
  RequestVerificationCodeWithRecoveryKeyQueryVariables
>;
export const GetOneTimePasswordDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'GetOneTimePassword' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'VerifyWithSmsInput' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'verificationMethod' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'registrationKey' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getOneTimePassword' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'verificationMethod' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'verificationMethod' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'registrationKey' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'registrationKey' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'UserError' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'message' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetOneTimePasswordMutation,
  GetOneTimePasswordMutationVariables
>;
export const VerifyOneTimePasswordNameDOBPhoneDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'VerifyOneTimePasswordNameDOBPhone' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'VerifyOTPInput' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'verificationMethod' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'verifyOneTimePassword' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'verificationMethod' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'verificationMethod' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'VerifySuccess' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'regToken' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'UserError' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'message' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  VerifyOneTimePasswordNameDOBPhoneMutation,
  VerifyOneTimePasswordNameDOBPhoneMutationVariables
>;
export const VerifyOneTimePasswordRegistrationKeyDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'VerifyOneTimePasswordRegistrationKey' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'VerifyOTPInput' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'verificationMethod' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'registrationKey' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'verifyOneTimePassword' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'verificationMethod' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'verificationMethod' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'registrationKey' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'registrationKey' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'VerifySuccess' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'regToken' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'UserError' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'message' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  VerifyOneTimePasswordRegistrationKeyMutation,
  VerifyOneTimePasswordRegistrationKeyMutationVariables
>;
export const ClaimTestDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'ClaimTest' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'claimsToken' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'registrationClaims' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'regToken' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'claimsToken' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ClaimTestMutation, ClaimTestMutationVariables>;
export const GetMyRiskOrdersDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetMyRiskOrders' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'orders' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'OrdersListSuccess' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'ordersList' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'externalId' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'accessionId' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'createDate' },
                            },
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'hasReleasedResults',
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'product' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'patientFirstName' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'patientLastName' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'sampleTracker' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'statusSummary',
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'sampleName' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'lastUpdated',
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'oneStepStatusTracker',
                                    },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'overallStatus',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'internalFlowStatus',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'isMerged',
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'statusTrackers',
                                    },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'patientName',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'trackerName',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'icon' },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'trackerSteps',
                                          },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'name',
                                                },
                                              },
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'status',
                                                },
                                              },
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'label',
                                                },
                                              },
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'description',
                                                },
                                              },
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'stepDate',
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetMyRiskOrdersQuery,
  GetMyRiskOrdersQueryVariables
>;
export const ResultsOverviewDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ResultsOverview' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'orderRequestId' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'resultsOverview' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'orderRequestId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'orderRequestId' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'ResultsOverviewSuccess' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'overallSeverity' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'resultsReleased' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'product' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'name' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'slug' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'patient' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'email' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'phone' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'firstName' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'lastName' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'accessionId' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'tests' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'testName' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'testStatus' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'testSeverity' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'reportId' },
                            },
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'resultsReleasedToPatient',
                              },
                            },
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'resultsViewedByPatient',
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'ReportNotReleased' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'status' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'message' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'UserNotFound' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'status' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'message' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'NotFound' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'status' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'message' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ResultsOverviewQuery,
  ResultsOverviewQueryVariables
>;
export const ReportsIDDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ReportsID' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'orderRequestId' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getReportIds' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'orderRequestId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'orderRequestId' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'GetReportIdsSuccess' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'reportIds' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ReportsIDQuery, ReportsIDQueryVariables>;
export const ClinicalReportDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ClinicalReport' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'reportUuid' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'orderRequestId' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getClinicalReport' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'reportUuid' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'reportUuid' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'orderRequestId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'orderRequestId' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'ReportSuccess' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'contentType' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'filename' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'report' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ClinicalReportQuery, ClinicalReportQueryVariables>;
export const GetOrderDetailsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetOrderDetails' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'externalId' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'orderDetails' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'externalId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'externalId' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'OrderDetailsSuccess' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'detail' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'accessionDate' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'patient' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'firstName' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'lastName' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'gender' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'dob' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'barcode' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'sampleReceived',
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'tests' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'type' },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'diseasePanel',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'testedDiseaseCount',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'conditions',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'reportDate',
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'receivingProvider',
                              },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'name' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'clinicName' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'clinicLocation',
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'orderingProvider' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'orderingClinic' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'billingInfo' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'description',
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'primaryInsuranceCard',
                                    },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'insuranceProvider',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'patientFirstName',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'patientLastName',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'patientAddress1',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'patientAddress2',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'patientCity',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'patientState',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'patientPostalCode',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'patientDob',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'relationshipToInsured',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'memberId',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'groupNumber',
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'secondaryInsuranceCard',
                                    },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'insuranceProvider',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'patientFirstName',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'patientLastName',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'patientAddress1',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'patientAddress2',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'patientCity',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'patientState',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'patientPostalCode',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'patientDob',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'relationshipToInsured',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'memberId',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'groupNumber',
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'partnerPrimaryInsuranceCard',
                                    },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'insuranceProvider',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'patientFirstName',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'patientLastName',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'patientAddress1',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'patientAddress2',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'patientCity',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'patientState',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'patientPostalCode',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'patientDob',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'relationshipToInsured',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'memberId',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'groupNumber',
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'partnerSecondaryInsuranceCard',
                                    },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'insuranceProvider',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'patientFirstName',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'patientLastName',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'patientAddress1',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'patientAddress2',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'patientCity',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'patientState',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'patientPostalCode',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'patientDob',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'relationshipToInsured',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'memberId',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'groupNumber',
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'creditCard' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'name' },
                                        },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'type' },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'last4',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'expMonth',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'expYear',
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetOrderDetailsQuery,
  GetOrderDetailsQueryVariables
>;
export const GetOrderRequestResultsReleasedDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetOrderRequestResultsReleased' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'externalId' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'orderDetails' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'externalId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'externalId' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'OrderDetailsSuccess' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'detail' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'hasReleasedResults',
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetOrderRequestResultsReleasedQuery,
  GetOrderRequestResultsReleasedQueryVariables
>;
export const GetMyAccountDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetMyAccount' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'account' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'profile' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'firstName' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'lastName' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'phoneNumber' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'timezone' },
                      },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'email' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetMyAccountQuery, GetMyAccountQueryVariables>;
export const UpdateAccountDetailsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateAccountDetails' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'ProfileInputType' },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateProfile' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'UpdateProfileSuccess' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'account' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'email' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'profile' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'firstName' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'lastName' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'phoneNumber',
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'timezone' },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateAccountDetailsMutation,
  UpdateAccountDetailsMutationVariables
>;
export const UpdateAccountAddressDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateAccountAddress' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'ProfileInputType' },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateProfile' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'UpdateProfileSuccess' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'account' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'email' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'profile' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'firstName' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'lastName' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'phoneNumber',
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'timezone' },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateAccountAddressMutation,
  UpdateAccountAddressMutationVariables
>;
